import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  useColorModeValue,
  Flex,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useAuth } from "../../context";
import { AnimatedBackground } from "../../components";
import { ReactComponent as Logo } from "./tnc-logo.svg";

function Home() {
  const { isAuthenticated } = useAuth();

  return (
    <Box
      overflow="hidden"
      border="10px solid"
      borderWidth={["8px", null, null, "10px"]}
      borderColor={useColorModeValue("white", "base.700")}
      height="calc(100vh - 3.5rem)"
    >
      <AnimatedBackground
        bgImage="/images/will-turner-W8W81BsgxX4-unsplash.jpg"
        bgSize={["contain", null, "auto"]}
        bgPos={["bottom", null, "25% 50%"]}
      />
      <Container
        background={`linear-gradient(130deg, ${useColorModeValue(
          "white",
          "var(--chakra-colors-base-700)"
        )} 55%, transparent)`}
        border={`1px solid ${useColorModeValue(
          "var(--chakra-colors-primary-100a)",
          "var(--chakra-colors-whiteAlpha-200)"
        )}`}
        borderRadius="lg"
        position="absolute"
        top={["5rem", null, "16vh"]}
        mx={[2, null, 12]}
        maxW={["fit-content", null, "container.sm", "container.md"]}
        px={[6, null, 8]}
        pt={[10, null, 8]}
        pb={[4, null, 6]}
        display="flex"
        flexDir="column"
        alignItems="flex-start"
        gap="3"
        backdropFilter="blur(16px)"
      >
        <Heading
          as="h2"
          fontSize={["md", null, "xl"]}
          mt="-2"
          fontFamily="mono"
          fontWeight="400"
          letterSpacing="2px"
          textTransform="uppercase"
        >
          WhalesAI.org
        </Heading>
        <Heading
          as="h1"
          fontSize={["4xl", null, "6xl"]}
          fontWeight="600"
          background="linear-gradient(125deg, var(--chakra-colors-teal-200), var(--chakra-colors-cyan-400), var(--chakra-colors-blue-700))"
          sx={{
            "-webkit-background-clip": "text",
            "-webkit-text-fill-color": "transparent",
          }}
        >
          Detect whales with satellite imagery
        </Heading>
        <Text fontSize={["md", null, "lg"]}>
          The Nature Conservancy&apos;s <strong>WhalesAI.org</strong>{" "}
          application permits validation of whale sightings detected via machine
          learning models on high resolution MAXAR imagery. Using machine
          learning models on satellite imagery will improve the state of whale
          monitoring and conservation by providing fast assessment of their
          location and pattern of movement at a species level.
        </Text>
        <Text fontSize={["md", null, "lg"]}>
          Log in to upload imagery and run models, or{" "}
          <Text
            as={Link}
            to="/explore"
            color={useColorModeValue("primary.700", "primary.400")}
          >
            view detections.
          </Text>
        </Text>
        <Box
          as="a"
          href="https://www.nature.org"
          p="4"
          transition="opacity 0.24s ease-out"
          _hover={{ opacity: "0.8" }}
        >
          <Logo width="180px" fill={useColorModeValue("#182e44", "white")} />
        </Box>
        <Box display="flex" alignSelf={["stretch", "flex-start"]} flexDir={["column", "row"]} gap={2} mt={2}>
          <Button
            variant="base"
            size={["md", "xl"]}
            as="a"
            href="https://docs.whalesai.org"
          >
            Learn More
          </Button>
          <Button
            variant="primary"
            size={["md", "xl"]}
            as={Link}
            to={isAuthenticated ? "/scenes" : "/login"}
          >
            Get Started
          </Button>
        </Box>
        <Flex flexDir={["column", null, "row"]} gap={[1, 6]} w="full" mt={2}>
          <Text
            as={Link}
            fontSize="xs"
            opacity={0.75}
            textDecoration="underline"
            to="/terms"
          >
            Terms of Service
          </Text>
          <Text
            as={Link}
            fontSize="xs"
            opacity={0.75}
            textDecoration="underline"
            to="/privacy"
          >
            Privacy Policy
          </Text>
          <Text fontSize="xs" opacity={0.75}>
            Image &copy;{" "}
            <a
              href="https://unsplash.com/photos/gray-whale-on-water-W8W81BsgxX4"
              target="_blank"
              rel="noopener noreferrer"
            >
              Will Turner on Unsplash
            </a>
          </Text>
        </Flex>
      </Container>
    </Box>
  );
}

export default Home;
